import React, { useState } from 'react'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'

import User from 'EurestoClass/User'
import Formulaire from 'Components/Formulaire'

import Moment from 'moment'
import { extendMoment } from 'moment-range'
import Search from '../../Component/Search'
import { Grid, Tooltip } from '@material-ui/core'

import { usePersistFn } from 'ahooks'
import Color from 'color'

const moment = extendMoment(Moment)

function checkNumberIfFloat(value) {
    return Number(value) === value && value % 1 !== 0;
}

const columns = [{
    header: 'Id',
    id: 'id',
    show: false,
}, {
    id: `date_debut`,
    header: `Date d'arrivée`,
    width: 150,
    type: 'string',
    Cell: row => {
        const range = moment.range(row.jour_debut, row.jour_fin)
        const nbJour = Array.from(range.by('days')).length
        return moment(row.date_debut).format('DD/MM/YY HH:mm') + " (" + (nbJour - 1) + "j)"
    }
}, {
    id: 'origine',
    width: 180,
    show: true,
    header: 'Origine',
    type: 'string',
    Cell: row => {
        return `${row.origine && row.origine.libelle}${row.ota ? ('- ' + row.ota.nom + ` (${row.ota.hotel_id})`) : ''}`
    }
}, {
    id: 'origine.reference',
    width: 100,
    show: true,
    header: 'ID Origine',
    type: 'string',
    Cell: row => {
        return `${row.origine && row.origine.reference}`
    }
}, {
    id: 'contact.libelle',
    show: true,
    header: 'Contact',
    type: 'string',
    Cell: row => {
        return `${row.contact && row.contact.libelle || ''}`
    }
}, {
    id: 'niveau',
    width: 30,
    header: 'Quantité',
    type: 'string',
    Cell: row => {
        return (
            <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
                alignItems={'center'} direction={'column'}>
                <i className={'EurestoPrimary--text'} style={{
                    borderRadius: '50%',
                    border: '1px solid black',
                    height: 25,
                    width: 25,
                    fontSize: 12,
                    fontWeight: 500,
                    color: row.niveau > 0 ? (Color(Utils.reservationColor(row.niveau)).isDark() ? 'white' : 'black') : 'black',
                    background: Utils.reservationColor(row.niveau, row.date_reservation)
                }}>
                    <Grid container style={{ height: '100%' }} justify={'center'}
                        alignItems={'center'} direction={'column'}>
                        {row.quantite}
                    </Grid></i>
            </Grid>
        )
    },
}, {
    id: 'montant_total',
    width: 100,
    header: 'Montant total',
    type: 'string',
    Cell: row => {
        return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
            alignItems={'center'} direction={'column'}>{(checkNumberIfFloat(row.montant_total) ? parseFloat(row.montant_total).toFixed(2) : parseInt(row.montant_total))}&nbsp;€
            </Grid>
    }
},
{
    header: 'Commentaire',
    id: 'commentaire',
    type: 'string',
    width: 150,
    Cell: row => {
        return (
            <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
                alignItems={'center'} direction={'column'}>
                {row.commentaire && <Tooltip disableTouchListener placement="bottom-end" title={
                    <div
                        dangerouslySetInnerHTML={{ __html: `<p>${row.commentaire}</p>` }}
                        style={{
                            fontSize: 15,
                            padding: 5,
                            paddingLeft: 10,
                            paddingRight: 10,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: '-moz-pre-wrap',
                            //wordBreak: 'break-all',
                            overflowWrap: 'break-word',
                            textAlign: 'left',
                            //lineHeight: '15px',
                        }} />
                }><div>Client : <i className={'fa fa-comment'} /></div></Tooltip>}
                {row.commentaire_interne && <Tooltip disableTouchListener placement="bottom-end" title={
                    <div
                        dangerouslySetInnerHTML={{ __html: `<p>${row.commentaire_interne}</p>` }}
                        style={{
                            fontSize: 15,
                            padding: 5,
                            paddingLeft: 10,
                            paddingRight: 10,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: '-moz-pre-wrap',
                            //wordBreak: 'break-all',
                            overflowWrap: 'break-word',
                            textAlign: 'left',
                            //lineHeight: '15px',
                        }} />
                }><div>Interne : <i className={'fa fa-comment'} /></div></Tooltip>}
            </Grid>
        )
    },
}, {
    header: 'Acquittement',
    id: 'acquittements',
    show: false,
    width: 150,
    type: 'string',
    Cell: row => {
        const acquittement = row.acquittements && row.acquittements.length > 0 && row.acquittements.slice(-1)[0]
        return (
            <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
                alignItems={'center'} direction={'column'}>
                {acquittement.id_externe}&nbsp;~&nbsp;{acquittement.status}&nbsp;
                {acquittement.commentaire && <Tooltip disableTouchListener placement="bottom-end" title={
                    <div
                        dangerouslySetInnerHTML={{ __html: `<p>${acquittement.commentaire}</p>` }}
                        style={{
                            fontSize: 15,
                            padding: 5,
                            paddingLeft: 10,
                            paddingRight: 10,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: '-moz-pre-wrap',
                            //wordBreak: 'break-all',
                            overflowWrap: 'break-word',
                            textAlign: 'left',
                            //lineHeight: '15px',
                        }} />
                }><div><i className={'fa fa-comment'} /></div></Tooltip>}
            </Grid>
        )
    },
}, {
    id: 'date_modification',
    width: 150,
    header: 'Date',
    Cell: row => {
        return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'center'}
            alignItems={'center'} direction={'column'}>{
                moment(row.date_creation).format('DD/MM/YY HH:mm')}
            <br />
            {moment(row.date_modification).format('DD/MM/YY HH:mm')}
        </Grid>
    }
}]


const isAllow = {
    add: false, update: false, delete: false
}
const formStyle = { padding: 0 }

export default React.memo(props => {

    const setAllow = usePersistFn((row) => ({
    }))

    const onClick = usePersistFn((row) => {
        console.log(row)
        const textArea = document.createElement('textarea')
        textArea.value = row.json
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('Copy')
        textArea.remove()
    })


    return <React.Fragment>
        <Formulaire
            infinityScroll={true}
            isAllow={isAllow}
            onClick={onClick}
            formStyle={formStyle}
            maxHeight={props.maxHeight}
            showSearchComponent={props && props.showSearch}
            searchComponent={props && props.showSearch && <Search
                defaultSearch={props && props.defaultSearch}
                searchName={props && props.searchName}
            />}
            setAllow={setAllow}
            showForm={false}
            search={props.search || ((props && props.searchName || 'api_hotel_reservation_') + (props.name || '') + User.Entite.get().id)}
            title={props.title}
            module={Constants.module.HOTEL}
            requete={Constants.donnee.reservation} columns={columns} />
    </React.Fragment>
})


// WEBPACK FOOTER //
// ./app/App/Module/Hotel/Page/Recherche/index.js